/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import IPais from './entidades/pais';

export default class ModeloPais {
    public consultarPais() {
        return manejadorRest<IRespuesta<IPais>>(() => seguridad.get('Pais/ConsultarListaPais'));
    }
    public crearPais(pais: IPais) {
        return manejadorRest<IRespuesta<IPais>>(() => seguridad.post('Pais/GuardarPais', pais));
    }
    public editarPais(pais: IPais) {
        return manejadorRest<IRespuesta<IPais>>(() => seguridad.put('Pais/EditarPais', pais));
    }
    public eliminarPais(pais: IPais) {
        return manejadorRest<IRespuesta<IPais>>(() => seguridad.delete('Pais/EliminarPais', pais));
    }
}
